import { Injectable } from '@angular/core'
import { UserIdService, WindowRef } from '@spartacus/core'
import { withLatestFrom } from 'rxjs/operators'
import { ActiveCartService, MultiCartService } from '@spartacus/cart/base/core'
import { MbConstants } from '../../shared/mb-constants'

@Injectable({
  providedIn: 'root'
})
export class MbActiveCartService extends ActiveCartService {

  protected shouldLoadCartOnCodeFlow = true

  constants = MbConstants

  constructor (protected multiCartService: MultiCartService,
               protected userIdService: UserIdService,
               protected winRef: WindowRef) {
    super(multiCartService, userIdService)
  }

  protected detectUserChange () {
    // Detect user logged in with code flow.
    if (this.isLoggedInWithCodeFlow()) {
      // Prevent loading cart while merging.
      this.shouldLoadCartOnCodeFlow = false

      this.subscription.add(
        this.userIdService
          .getUserId()
          .pipe(withLatestFrom(this.activeCartId$))
          .subscribe(([_userId, _cartId]) => {
            this.winRef?.localStorage?.removeItem(MbConstants.OAUTH_REDIRECT_FLOW_KEY)
          })
      )
    }
  }

  protected isLoggedInWithCodeFlow () {
    return !!this.winRef?.localStorage?.getItem(MbConstants.OAUTH_REDIRECT_FLOW_KEY)
  }
}
